<template>
  <div class="account-billing-details-display">
    <div class="row">
      <div class="col-sm-12">
        <div class="toolbar pull-right">
          <router-link class="btn btn-default"
            :to="{ path: `/membership/members/${account.uuid}` }">
            <span class="fa fa-user fa-fw"></span> Account Details
          </router-link>
          <router-link class="btn btn-default"
            :to="{ path: `/membership/members/billing/${account.uuid}` }">
            <span class="fa fa-dollar-sign fa-fw"></span> Billing Details
          </router-link>
          <a class="btn btn-info" @click="uploadFileModal()">
            <span class="fa fa-upload fa-fw"></span> Upload File
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <responsive-table v-if="fileView.rows.length > 0" :table="fileView"></responsive-table>
        <p class="alert alert-danger text-strong" v-else>
          <strong>No files found for this account. Click 'upload file' to add one.</strong>
        </p>
      </div>
    </div>
    <!-- upload modal -->
    <modal ref="uploadModal" v-if="uploading">
      <template slot="header">
        <h4 class="modal-title">Upload File</h4>
      </template>
      <template slot="body">
        <form class="form-horizontal">
          <text-input v-bind:field="fileType"></text-input>
          <amazon-media-input v-bind:field="newFile"></amazon-media-input>
        </form>
      </template>
      <template slot="footer">
        <button class="btn btn-default pull-left" data-dismiss="modal" type="button">Dismiss</button>
        <button @click="uploadFile()" class="btn btn-info" data-dismiss="modal" type="button">Upload</button>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from '../Modal'
import TextInput from '../inputs/TextInput'
import ResponsiveTable from '../ResponsiveTable'
import AmazonMediaInput from '../inputs/AmazonMediaInput'

export default {
  name: 'AccountBillingDetailsDisplay',
  components: {
    ResponsiveTable,
    Modal,
    TextInput,
    AmazonMediaInput
  },
  data () {
    return {
      newFile: {
        name: 'newFile',
        label: 'New File: ',
        value: '',
        valid: false,
        dirty: false
      },
      fileType: {
        name: 'fileType',
        label: 'File Type: ',
        value: 'File',
        valid: false,
        dirty: false
      },
      uploading: false,
      account: {
        uuid: ''
      },
      fileView: {
        title: 'Files',
        count: 0,
        columns: [],
        rows: []
      }
    }
  },
  route: {
    data () {
      this.account.uuid = this.$route.params.account_id
      this.getFiles()
    }
  },
  methods: {
    getFiles () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/files`, {
        params: { accountId: this.$route.params.account_id }
      }).then(({ data }, status, request) => {
        this.fileView = data.object
      })
    },
    uploadFileModal () {
      this.uploading = true
      this.$nextTick(function () {
        $(this.$refs.uploadModal).modal()
        $(this.$refs.uploadModal).on('hidden.bs.modal', (e) => {
          this.uploading = false
        })
      })
    },
    uploadFile () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.post(`${meta.authType}/object/uploadFile`, {
        type: this.fileType.value,
        file: this.newFile.value,
        accountId: this.account.uuid
      }).then(({ data }, status, request) => {
        this.getFiles()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AccountFilesDisplay.vue